import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';
import { NomWebServicesJson } from '@src/suite/common/services/nom-web-services-json';
import { ChatCompletionMessageParam } from 'openai/resources';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PlaybookOpenAiService {
    constructor(
        public nomWebServicesJson: NomWebServicesJson,
        public httpClient: HttpClient
    ) {}

    getPrompts(): Observable<any> {
        return this.httpClient.get('./assets/prompts.json').pipe(map(data => data));
    }

    private getCompletion(prompt: string, maxTokens: number) {
        const url: string = 'https://api.openai.com/v1/chat/completions';
        const requestParams = {
            model: 'gpt-4-turbo-preview',
            messages: [{ role: 'user', content: prompt }] as ChatCompletionMessageParam[],
            max_tokens: maxTokens,
        };
        return this.httpClient
            .post(url, requestParams, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${environment.open_ai_api_key}`,
                }),
            })
            .pipe(
                map(res => {
                    return res?.['choices']?.[0]?.['message']?.['content'] || '';
                })
            );
    }

    public getCustomPrompt(storyText: string, text: string, maxTokens: number): Observable<any> {
        const prompt = `${text}: ${storyText}`;
        return this.getCompletion(prompt, maxTokens);
    }
}
